import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "finance-container" }
const _hoisted_2 = { class: "finance-section" }
const _hoisted_3 = {
  key: 1,
  class: "finance-info"
}
const _hoisted_4 = { class: "trip-details" }
const _hoisted_5 = { class: "detail-row" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "detail-row" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "price-breakdown" }
const _hoisted_10 = { class: "breakdown-item" }
const _hoisted_11 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_12 = { class: "breakdown-item" }
const _hoisted_13 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_14 = { class: "breakdown-item" }
const _hoisted_15 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_16 = {
  key: 2,
  class: "breakdown-item"
}
const _hoisted_17 = { class: "breakdown-item" }
const _hoisted_18 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_19 = { class: "breakdown-item" }
const _hoisted_20 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_21 = { class: "breakdown-item" }
const _hoisted_22 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_23 = {
  key: 2,
  class: "breakdown-item"
}
const _hoisted_24 = {
  key: 3,
  class: "breakdown-item"
}
const _hoisted_25 = { class: "breakdown-item" }
const _hoisted_26 = { class: "breakdown-item" }
const _hoisted_27 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_28 = {
  key: 1,
  class: "breakdown-item"
}
const _hoisted_29 = { class: "breakdown-item" }
const _hoisted_30 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_31 = { class: "breakdown-item" }
const _hoisted_32 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_33 = { class: "breakdown-item" }
const _hoisted_34 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_35 = {
  key: 2,
  class: "breakdown-item"
}
const _hoisted_36 = {
  key: 3,
  class: "breakdown-item"
}
const _hoisted_37 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_38 = {
  key: 1,
  class: "breakdown-item"
}
const _hoisted_39 = {
  key: 2,
  class: "breakdown-item"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 3,
  class: "breakdown-item"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "summary" }
const _hoisted_47 = { class: "summary-item" }
const _hoisted_48 = { class: "value total" }
const _hoisted_49 = { class: "summary-item" }
const _hoisted_50 = { class: "value paid" }
const _hoisted_51 = { class: "summary-item" }
const _hoisted_52 = { class: "finance-section" }
const _hoisted_53 = { class: "operations-table" }
const _hoisted_54 = { class: "operation-type" }
const _hoisted_55 = { class: "amount" }
const _hoisted_56 = { class: "amount" }
const _hoisted_57 = { class: "amount" }
const _hoisted_58 = {
  key: 0,
  class: "no-data"
}
const _hoisted_59 = {
  key: 1,
  class: "no-data"
}
const _hoisted_60 = {
  key: 2,
  class: "no-data"
}
const _hoisted_61 = { class: "table-actions" }
const _hoisted_62 = { class: "finance-section" }
const _hoisted_63 = {
  key: 0,
  class: "field-operator-warning"
}
const _hoisted_64 = {
  key: 1,
  class: "finish-payment"
}
const _hoisted_65 = { class: "payment-grid" }
const _hoisted_66 = { class: "payment-group" }
const _hoisted_67 = { class: "payment-group action-group" }
const _hoisted_68 = { class: "payment-group amount-group" }
const _hoisted_69 = { class: "payment-group finish-btn-group" }
const _hoisted_70 = { class: "transactions-dialog" }

import { computed, ref, onMounted, watch, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { DateTime } from 'luxon'

import { EvTrip, EvTripPricingType } from '@/models/evTrip'
import { EvRole } from '@/models/evAdmin'
import * as evTripsApi from '@/api/ev-trips'
import { parseErrors } from '@/helpers/error-parsers'
import { useEvTripsStore } from '@/store/evTrips'
import { useAuthStore } from '@/store/auth'

import TransactionsTable from './TransactionsTable.vue'
import DiscountModal from './DiscountModal.vue'

const UPDATE_INTERVAL_MS = 30000 // 30 seconds for ongoing trips

const EPSILON = 1e-6


export default /*@__PURE__*/_defineComponent({
  __name: 'FinanceSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props
const evTripsStore = useEvTripsStore()
const authStore = useAuthStore()

const isFieldOperator = computed(() => {
  const currentUser = authStore.session?.user
  return currentUser?.ev_role === EvRole.FIELD_OPERATOR
})

// Reactive data
const showDiscountDialog = ref(false)
const showTransactionsDialog = ref(false)
const paymentType = ref('deposit')
const paymentAction = ref('charge')
const paymentAmount = ref('')
const processingPayment = ref(false)
const processingDiscount = ref(false)
const removingDiscount = ref(false)
const activeTransactionTab = ref('deposit')

// Discounts data
const appliedDiscounts = ref<
  Array<{
    id: string
    amount: number
    reason?: string
    admin_id?: string
    applied_at: string
  }>
>([])

// Finance data from API
const financeInfo = ref<{
  finance_info?: {
    start_date?: string
    end_date?: string
    total_distance?: number
    paid_amount?: number
    outstanding_amount?: number
    price_breakdown?: {
      start_price?: number
      amount_up_to_100km?: number
      amount_above_100km?: number
      amount_pause?: number
    }
  }
} | null>(null)

const creditCardOperations = ref<any>(null)

const depositTransactions = ref<
  Array<{
    id: string
    amount: number
    status: string
    payriff_type: string
    order_status: string
    type: string
    description?: string
    created_at: string
  }>
>([])

const serviceTransactions = ref<
  Array<{
    id: string
    amount: number
    status: string
    payriff_type: string
    order_status: string
    type: string
    description?: string
    created_at: string
  }>
>([])

const finesTransactions = ref<
  Array<{
    id: string
    amount: number
    status: string
    payriff_type: string
    order_status: string
    type: string
    description?: string
    created_at: string
  }>
>([])
const loadingFinance = ref(false)
const loadingTransactions = ref(false)

// Real-time update management
const updateInterval = ref<ReturnType<typeof setInterval> | null>(null)
const isTripCancelled = computed(() => {
  if (!props.trip?.status) return false
  const status = props.trip.status.toLowerCase()
  return status.startsWith('cancel') || status.startsWith('decline')
})

// Computed properties for trip data
const tripTotal = computed(() => {
  if (!props.trip || isTripCancelled.value) {
    return 0
  }

  // For ongoing trips, calculate from real-time price breakdown if available
  if (props.trip.status === 'ongoing' || !props.trip.end_date) {
    const breakdown = financeInfo.value?.finance_info?.price_breakdown
    if (breakdown) {
      const calculatedTotal =
        (breakdown.start_price || 0) +
        (breakdown.amount_up_to_100km || 0) +
        (breakdown.amount_above_100km || 0) +
        (breakdown.amount_pause || 0)
      return calculatedTotal
    }
  }

  // Use trip total_amount if available and non-zero
  const tripTotalAmount = parseFloat(String(props.trip.total_amount || 0))
  if (tripTotalAmount > 0) {
    return tripTotalAmount
  }

  // Fallback to per_minute_breakdown total_amount if trip total is 0
  if (props.trip.per_minute_breakdown?.total_amount) {
    return parseFloat(String(props.trip.per_minute_breakdown.total_amount))
  }

  // Fallback to per_hour_breakdown total_amount
  if (props.trip.per_hour_breakdown?.total_amount) {
    return parseFloat(String(props.trip.per_hour_breakdown.total_amount))
  }

  // Fallback to rush_breakdown total_amount
  if (props.trip.rush_breakdown?.total_amount) {
    return parseFloat(String(props.trip.rush_breakdown.total_amount))
  }

  // Fallback to per_day_breakdown total_amount
  if (props.trip.per_day_breakdown?.total_amount) {
    return parseFloat(String(props.trip.per_day_breakdown.total_amount))
  }

  return 0
})

const paidAmount = computed(() => {
  if (!creditCardOperations.value) {
    return 0
  }

  // Handle different possible data structures
  let operationsData = creditCardOperations.value

  // If data is nested under payment_summary
  if (operationsData.payment_summary) {
    operationsData = operationsData.payment_summary
  }

  // If data is nested under transaction_details
  if (operationsData.transaction_details) {
    operationsData = operationsData.transaction_details
  }

  // Calculate total charged amount from all payment types
  const depositCharged = operationsData.deposit?.charged || 0
  const serviceCharged = operationsData.service?.charged || 0
  const finesCharged = operationsData.fines?.charged || 0

  const total = depositCharged + serviceCharged + finesCharged

  return total
})

const outstandingAmount = computed(() => {
  if (!props.trip) return 0
  const total = tripTotal.value
  const paid = paidAmount.value

  return total - paid
})

const formattedOutstanding = computed(() => {
  const amount = outstandingAmount.value

  // якщо близько до нуля → вважати нулем
  if (Math.abs(amount) < EPSILON) {
    return `₼${formatAmount(0)}`
  }

  if (amount < 0) {
    return `-₼${formatAmount(Math.abs(amount))}`
  }

  return `₼${formatAmount(amount)}`
})

const creditCardData = computed(() => {
  if (!creditCardOperations.value) {
    return []
  }

  let operationsData = creditCardOperations.value

  // Try different possible data structures
  if (operationsData.payment_summary) {
    operationsData = operationsData.payment_summary
  } else if (operationsData.transaction_details) {
    operationsData = operationsData.transaction_details
  } else if (operationsData.data) {
    operationsData = operationsData.data
  }

  // Create table data with default values
  const data = [
    {
      type: 'Deposit',
      frozen: operationsData?.deposit?.frozen || 0,
      charged: operationsData?.deposit?.charged || 0,
      refunded: operationsData?.deposit?.refunded || 0,
    },
    {
      type: 'Service',
      frozen: operationsData?.service?.frozen || 0,
      charged: operationsData?.service?.charged || 0,
      refunded: operationsData?.service?.refunded || 0,
    },
    {
      type: 'Fines',
      frozen: operationsData?.fines?.frozen || 0,
      charged: operationsData?.fines?.charged || 0,
      refunded: operationsData?.fines?.refunded || 0,
    },
  ]
  return data
})

const setFullAmount = () => {
  if (!creditCardData.value) return

  // Find the credit card data entry that matches the selected payment type
  // Note: paymentType is lowercase ('deposit', 'service', 'fines')
  // while creditCardData.type is Capitalized ('Deposit', 'Service', 'Fines')
  const typeLabel =
    paymentType.value.charAt(0).toUpperCase() + paymentType.value.slice(1)
  const data = creditCardData.value.find((item: any) => item.type === typeLabel)

  if (!data) return

  let amount = 0

  // Logic:
  // - If unfreezing, use the frozen amount
  // - If charging, prioritize frozen amount (common for deposit),
  //   otherwise we might want to charge outstanding but that's complex,
  //   so let's stick to frozen as per user request ("if we froze 5 and want to charge")
  // - If refunding, use the charged amount
  // - Freezing is usually manual amount entry, so we don't autofill

  if (paymentAction.value === 'unfreeze') {
    amount = data.frozen
  } else if (paymentAction.value === 'charge') {
    amount = data.frozen
  } else if (paymentAction.value === 'refund') {
    amount = data.charged
  }

  if (amount > 0) {
    paymentAmount.value = amount.toString()
  }
}

// Duration calculations for display
const pauseMinutes = computed(() => {
  if (!props.trip) return 0
  return props.trip.total_pause_minutes || 0
})

const drivingMinutes = computed(() => {
  if (!props.trip) return 0
  return parseFloat(String(props.trip.time_up_to_100km_minutes || 0))
})

const extraMinutes = computed(() => {
  if (!props.trip) return 0
  return parseFloat(String(props.trip.time_above_to_100km_minutes || 0))
})

const extraDistance = computed(() => {
  if (!props.trip) return 0
  return props.trip.extra_distance_km || 0
})

const tariffDistanceLimit = computed(() => {
  if (!props.trip) return 100
  return props.trip.max_distance_per_tariff || 100
})

// Helper functions
const formatTripDateTime = () => {
  if (!props.trip?.start_date) return '-'

  const start = DateTime.fromISO(props.trip.start_date)
  const end = props.trip.end_date ? DateTime.fromISO(props.trip.end_date) : null

  const startFormatted = start.toFormat('MMM dd, h:mm a')
  const endFormatted = end ? end.toFormat('MMM dd, h:mm a') : 'Ongoing'

  return `${startFormatted} - ${endFormatted}`
}

const formatDistance = (distance: number | null | undefined) => {
  if (!distance) return '-'
  return `${Number(distance).toFixed(2)} km`
}

const formatDuration = (minutes: number | null) => {
  if (!minutes) return '-'
  return `${Math.round(minutes)} mins`
}

const getRushMinutePackageDurationMinutes = () => {
  const minuteIntervals = props.trip?.rush_breakdown?.minute_intervals || []

  if (minuteIntervals.length) {
    return minuteIntervals.reduce(
      (sum, interval) => sum + Number(interval.duration_minutes || 0),
      0
    )
  }

  return props.trip?.rush_breakdown?.minute_phase?.total_duration_minutes || 0
}

const formatAmount = (amount: number | string | null) => {
  if (amount === null || amount === undefined) return '0.00'

  // Convert to number if it's a string
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numAmount)) return '0.00'
  return numAmount.toFixed(2)
}

// Actions
const handleApplyDiscount = async (payload: {
  amount: number
  reason: string
}) => {
  try {
    processingDiscount.value = true
    await evTripsApi.applyDiscount(
      props.trip!.id,
      payload.amount,
      payload.reason
    )

    ElMessage.success('Discount applied successfully')
    showDiscountDialog.value = false

    // Reload discounts and refresh trip data in store
    await loadDiscounts()
    await evTripsStore.getEvTripDetails(props.trip!.id)
  } catch (error) {
    console.error('Failed to apply discount:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to apply discount')
  } finally {
    processingDiscount.value = false
  }
}

const removeDiscountHandler = async (discountId: string) => {
  try {
    removingDiscount.value = true
    await evTripsApi.removeDiscount(props.trip!.id, discountId)

    ElMessage.success('Discount removed successfully')

    // Reload discounts and refresh trip data in store
    await loadDiscounts()
    await evTripsStore.getEvTripDetails(props.trip!.id)
  } catch (error) {
    console.error('Failed to remove discount:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to remove discount')
  } finally {
    removingDiscount.value = false
  }
}

const processPayment = async () => {
  if (isFieldOperator.value) {
    ElMessage.warning(
      'Field operators are not allowed to execute manual transactions'
    )
    return
  }

  if (!paymentAmount.value) {
    ElMessage.warning('Please enter an amount')
    return
  }

  try {
    processingPayment.value = true

    const paymentData = {
      transaction_type: paymentType.value,
      action: paymentAction.value,
      amount: parseFloat(paymentAmount.value),
      amount_src: parseFloat(paymentAmount.value),
    }

    await evTripsApi.processPayment(props.trip!.id, paymentData)

    ElMessage.success('Payment processed successfully')
    paymentAmount.value = ''

    // Reload finance data to reflect changes immediately
    await Promise.all([loadFinanceData(), loadTransactions()])
  } catch (error) {
    console.error('Failed to process payment:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to process payment')
  } finally {
    processingPayment.value = false
  }
}

const loadDiscounts = async () => {
  if (!props.trip?.id) {
    console.warn('⚠️ No trip ID available for loading discounts')
    return
  }

  try {
    const response = await evTripsApi.getDiscounts(props.trip.id)

    // Handle structure: data.discounts
    const discountsData = response.data.data as any
    if (discountsData && discountsData.discounts) {
      appliedDiscounts.value = discountsData.discounts
    } else if (Array.isArray(discountsData)) {
      // Fallback: if data is directly an array
      appliedDiscounts.value = discountsData
    } else {
      appliedDiscounts.value = []
    }
  } catch (error) {
    console.error('❌ Failed to load discounts:', error)
    // Don't show error message for discounts as it's not critical
    appliedDiscounts.value = []
  }
}

// Real-time update functions
const startRealTimeUpdates = () => {
  if (updateInterval.value) {
    clearInterval(updateInterval.value)
  }

  // Only start real-time updates for ongoing trips
  if (props.trip && (props.trip.status === 'ongoing' || !props.trip.end_date)) {
    const tripId = props.trip.id
    updateInterval.value = setInterval(async () => {
      try {
        await Promise.all([
          loadFinanceData(),
          evTripsStore.getEvTripDetails(tripId),
        ])
      } catch (error) {
        console.error('Error updating real-time data:', error)
      }
    }, UPDATE_INTERVAL_MS)
  }
}

const stopRealTimeUpdates = () => {
  if (updateInterval.value) {
    clearInterval(updateInterval.value)
    updateInterval.value = null
  }
}

const loadFinanceData = async () => {
  if (!props.trip?.id) return

  try {
    loadingFinance.value = true

    // Load finance info and credit card operations in parallel
    const [financeResponse, operationsResponse] = await Promise.all([
      evTripsApi.getFinanceInfo(props.trip.id),
      evTripsApi.getCreditCardOperations(props.trip.id),
    ])

    financeInfo.value = financeResponse.data.data
    creditCardOperations.value = operationsResponse.data.data
  } catch (error) {
    console.error('Failed to load finance data:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to load finance data')
  } finally {
    loadingFinance.value = false
  }
}

const loadTransactions = async () => {
  if (!props.trip?.id) return

  try {
    loadingTransactions.value = true

    // Load all transactions at once
    const response = await evTripsApi.getTransactions(props.trip.id)

    const transactionsData = response.data.data as any

    depositTransactions.value = transactionsData?.transactions?.deposit || []
    serviceTransactions.value = transactionsData?.transactions?.service || []
    finesTransactions.value = transactionsData?.transactions?.fines || []
  } catch (error) {
    console.error('Failed to load transactions:', error)
    const { error: errorMessage } = parseErrors(error)
    ElMessage.error(errorMessage || 'Failed to load transactions')
  } finally {
    loadingTransactions.value = false
  }
}

onMounted(async () => {
  if (props.trip?.id) {
    await Promise.all([loadFinanceData(), loadTransactions(), loadDiscounts()])
  }

  // Start real-time updates if this is an ongoing trip
  startRealTimeUpdates()
})

onUnmounted(() => {
  stopRealTimeUpdates()
})

// Watch for trip status changes to start/stop real-time updates
watch(
  () => props.trip?.status,
  (newStatus, oldStatus) => {
    if (newStatus === 'ongoing') {
      startRealTimeUpdates()
    } else if (oldStatus === 'ongoing' && newStatus !== 'ongoing') {
      stopRealTimeUpdates()
      // Refresh data one final time when trip ends
      loadFinanceData()
    }
  },
  { immediate: false }
)

// Watch for trip end_date changes (another way to detect trip completion)
watch(
  () => props.trip?.end_date,
  (newEndDate, oldEndDate) => {
    if (!oldEndDate && newEndDate) {
      stopRealTimeUpdates()
      // Refresh data when trip ends
      loadFinanceData()
    } else if (oldEndDate && !newEndDate) {
      startRealTimeUpdates()
    }
  },
  { immediate: false }
)

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("h4", { class: "section-title" }, "FINANCE INFO", -1)),
      (!props.trip)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Date and Time:", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(formatTripDateTime()), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Total Range:", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(formatDistance(props.trip?.total_trip_distance)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Price Breakdown:", -1)),
              (
              props.trip?.pricing_type === _unref(EvTripPricingType).PER_HOUR &&
                props.trip?.per_hour_breakdown
            )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (
                props.trip?.pricing_type === _unref(EvTripPricingType).PER_HOUR &&
                  props.trip?.per_hour_breakdown
              )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", null, " Hourly package (limit " + _toDisplayString(props.trip.per_hour_breakdown.base_hour.limit_km) + " km): ", 1),
                            _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.per_hour_breakdown.base_hour.base_amount
                      )), 1)
                          ]),
                          (props.trip.per_hour_breakdown.base_hour.over_limit_km > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("span", null, " Extra km limit Hourly Package (" + _toDisplayString(props.trip.per_hour_breakdown.base_hour.over_limit_km) + " km): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.per_hour_breakdown.base_hour.extra_km_amount
                      )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trip.per_hour_breakdown.extends ||
                  [], (ext, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", null, " Extend Hourly package (limit " + _toDisplayString(ext.limit_km) + " km): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.base_amount)), 1)
                              ]),
                              (ext.over_limit_km > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("span", null, " Extend Extra km limit Hourly Package (" + _toDisplayString(ext.over_limit_km) + " km): ", 1),
                                    _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.extra_km_amount)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (
                  props.trip.per_hour_breakdown.minute_phase &&
                    parseFloat(
                      String(props.trip.per_hour_breakdown.minute_phase.amount)
                    ) > 0
                )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("span", null, " Minute package (" + _toDisplayString(formatDuration(
                        props.trip.per_hour_breakdown.minute_phase
                          .total_duration_minutes
                      )) + "): ", 1),
                                  _createElementVNode("span", null, _toDisplayString('₼' +
                        formatAmount(
                          props.trip.per_hour_breakdown.minute_phase.base_amount
                        )), 1)
                                ]),
                                (
                    props.trip.per_hour_breakdown.minute_phase.over_limit_km > 0
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createElementVNode("span", null, " Extra km Minute package (" + _toDisplayString(props.trip.per_hour_breakdown.minute_phase.over_limit_km) + " km): ", 1),
                                      _createElementVNode("span", null, _toDisplayString('₼' +
                        formatAmount(
                          props.trip.per_hour_breakdown.minute_phase
                            .extra_km_amount
                        )), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                  props.trip.per_hour_breakdown.pause &&
                    props.trip.per_hour_breakdown.pause.amount > 0
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("span", null, " Pause (" + _toDisplayString(formatDuration(
                      props.trip.per_hour_breakdown.pause.duration_minutes
                    )) + "): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(props.trip.per_hour_breakdown.pause.amount)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (
              props.trip?.pricing_type === _unref(EvTripPricingType).RUSH_HOUR &&
                props.trip?.rush_breakdown
            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", null, " Rush package (limit " + _toDisplayString(props.trip.rush_breakdown.rush_phase.limit_km) + " km): ", 1),
                        _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(
                      props.trip.rush_breakdown.rush_phase.base_amount
                    )), 1)
                      ]),
                      (props.trip.rush_breakdown.rush_phase.over_limit_km > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("span", null, " Extra km limit Rush Package (" + _toDisplayString(props.trip.rush_breakdown.rush_phase.over_limit_km) + " km): ", 1),
                            _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(
                      props.trip.rush_breakdown.rush_phase.extra_km_amount
                    )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trip.rush_breakdown.extends || [], (ext, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", null, " Extend Rush package (limit " + _toDisplayString(ext.limit_km) + " km): ", 1),
                            _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.base_amount)), 1)
                          ]),
                          (ext.over_limit_km > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("span", null, " Extend Extra km limit Rush Package (" + _toDisplayString(ext.over_limit_km) + " km): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.extra_km_amount)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (
                props.trip.rush_breakdown.minute_phase &&
                  parseFloat(
                    String(props.trip.rush_breakdown.minute_phase.amount)
                  ) > 0
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("span", null, " Minute package (" + _toDisplayString(formatDuration(getRushMinutePackageDurationMinutes())) + "): ", 1),
                              _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.rush_breakdown.minute_phase.base_amount
                      )), 1)
                            ]),
                            (props.trip.rush_breakdown.minute_phase.over_limit_km > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("span", null, " Extra km Minute package (" + _toDisplayString(props.trip.rush_breakdown.minute_phase.over_limit_km) + " km): ", 1),
                                  _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.rush_breakdown.minute_phase.extra_km_amount
                      )), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                props.trip.rush_breakdown.pause &&
                  props.trip.rush_breakdown.pause.amount > 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("span", null, " Pause (" + _toDisplayString(formatDuration(
                    props.trip.rush_breakdown.pause.duration_minutes
                  )) + "): ", 1),
                            _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip.rush_breakdown.pause.amount)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                parseFloat(String(props.trip.rush_breakdown.deposit || 0)) > 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Deposit:", -1)),
                            _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(Number(props.trip.rush_breakdown.deposit))), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (
              props.trip?.pricing_type === _unref(EvTripPricingType).PER_MINUTE &&
                props.trip?.per_minute_breakdown
            )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_25, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Start Price:", -1)),
                          _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(props.trip.per_minute_breakdown.start_price)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", null, " Minute package (limit " + _toDisplayString(props.trip.per_minute_breakdown.limit_km) + " km, " + _toDisplayString(formatDuration(
                    props.trip.per_minute_breakdown.duration_minutes
                  )) + "): ", 1),
                          _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(props.trip.per_minute_breakdown.base_amount)), 1)
                        ]),
                        (props.trip.per_minute_breakdown.over_limit_km > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("span", null, " Extra km Minute package (" + _toDisplayString(props.trip.per_minute_breakdown.over_limit_km) + " km): ", 1),
                              _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(
                      props.trip.per_minute_breakdown.extra_km_amount
                    )), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                parseFloat(
                  String(props.trip.per_minute_breakdown.pause.amount)
                ) > 0
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("span", null, " Pause (" + _toDisplayString(formatDuration(
                    props.trip.per_minute_breakdown.pause.duration_minutes
                  )) + "): ", 1),
                              _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(props.trip.per_minute_breakdown.pause.amount)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (
              props.trip?.pricing_type === _unref(EvTripPricingType).PER_DAY &&
                props.trip?.per_day_breakdown
            )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", null, " Daily package (limit " + _toDisplayString(props.trip.per_day_breakdown.base_day.limit_km) + " km): ", 1),
                            _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(
                      props.trip.per_day_breakdown.base_day.base_amount
                    )), 1)
                          ]),
                          (props.trip.per_day_breakdown.base_day.over_limit_km > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("span", null, " Extra km limit Daily Package (" + _toDisplayString(props.trip.per_day_breakdown.base_day.over_limit_km) + " km): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' +
                    formatAmount(
                      props.trip.per_day_breakdown.base_day.extra_km_amount
                    )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.trip.per_day_breakdown.extends || [], (ext, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", null, " Extend Hourly package (limit " + _toDisplayString(ext.limit_km) + " km): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.base_amount)), 1)
                              ]),
                              (ext.over_limit_km > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("span", null, " Extend Extra km limit Hourly Package (" + _toDisplayString(ext.over_limit_km) + " km): ", 1),
                                    _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(ext.extra_km_amount)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          (
                props.trip.per_day_breakdown.minute_phase &&
                  parseFloat(
                    String(props.trip.per_day_breakdown.minute_phase.amount)
                  ) > 0
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", null, " Minute package (" + _toDisplayString(formatDuration(
                      props.trip.per_day_breakdown.minute_phase
                        .total_duration_minutes
                    )) + "): ", 1),
                                  _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.per_day_breakdown.minute_phase.base_amount
                      )), 1)
                                ]),
                                (
                  props.trip.per_day_breakdown.minute_phase.extra_km_amount > 0
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _cache[12] || (_cache[12] = _createElementVNode("span", null, " Extra km Minute package: ", -1)),
                                      _createElementVNode("span", null, _toDisplayString('₼' +
                      formatAmount(
                        props.trip.per_day_breakdown.minute_phase
                          .extra_km_amount
                      )), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                props.trip.per_day_breakdown.pause &&
                  props.trip.per_day_breakdown.pause.amount > 0
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("span", null, " Pause (" + _toDisplayString(formatDuration(
                    props.trip.per_day_breakdown.pause.duration_minutes
                  )) + "): ", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip.per_day_breakdown.pause.amount)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                parseFloat(
                  String(props.trip.per_day_breakdown.discount_amount || 0)
                ) > 0
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Discount:", -1)),
                                _createElementVNode("span", null, _toDisplayString('-₼' +
                    formatAmount(
                      Number(props.trip.per_day_breakdown.discount_amount)
                    )), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (props.trip?.pricing_type === _unref(EvTripPricingType).PER_MINUTE)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Start Price:", -1)),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip?.start_price || 0)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (parseFloat(String(props.trip?.amount_pause || '0')) > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("span", null, "Pause (" + _toDisplayString(formatDuration(pauseMinutes.value)) + "):", 1),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip?.amount_pause || 0)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                parseFloat(String(props.trip?.amount_up_to_100km || '0')) > 0
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                (props.trip?.pricing_type === _unref(EvTripPricingType).PER_HOUR)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, " Hourly package (limit " + _toDisplayString(tariffDistanceLimit.value) + " km): ", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(formatDuration(drivingMinutes.value)) + " (limit " + _toDisplayString(tariffDistanceLimit.value) + " km): ", 1)),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip?.amount_up_to_100km || 0)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                parseFloat(String(props.trip?.amount_above_to_100km || '0')) > 0
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                (extraMinutes.value > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(formatDuration(extraMinutes.value)) + " (extra):", 1))
                                  : (extraDistance.value > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Extra km (" + _toDisplayString(formatDistance(extraDistance.value)) + "):", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_45, "Extra:")),
                                _createElementVNode("span", null, _toDisplayString('₼' + formatAmount(props.trip?.amount_above_to_100km || 0)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "Total:", -1)),
                _createElementVNode("span", _hoisted_48, _toDisplayString('₼' + formatAmount(tripTotal.value)), 1),
                (!isTripCancelled.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showDiscountDialog.value = true))
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" Discount ")
                      ])),
                      _: 1,
                      __: [16]
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "Paid:", -1)),
                _createElementVNode("span", _hoisted_50, _toDisplayString('₼' + formatAmount(paidAmount.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "Outstanding:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["value outstanding", {
                negative: outstandingAmount.value < -EPSILON,
                zero: Math.abs(outstandingAmount.value) < EPSILON
              }])
                }, _toDisplayString(formattedOutstanding.value), 3)
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_52, [
      _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "section-title" }, "CREDIT CARD OPERATIONS", -1)),
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_el_table, {
          data: creditCardData.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Type",
              "min-width": "120"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_54, _toDisplayString(row.type), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Deposit Frozen",
              "min-width": "140"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_55, "₼" + _toDisplayString(formatAmount(row.frozen)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Deposit Charged",
              "min-width": "140"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_56, "₼" + _toDisplayString(formatAmount(row.charged)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Deposit Refunded",
              "min-width": "140"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_57, "₼" + _toDisplayString(formatAmount(row.refunded)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        (loadingFinance.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[21] || (_cache[21] = [
              _createElementVNode("p", null, "Loading credit card operations...", -1)
            ])))
          : (!creditCardOperations.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, _cache[22] || (_cache[22] = [
                _createElementVNode("p", null, "Failed to load credit card operations", -1)
              ])))
            : (
            creditCardData.value.every(
              item =>
                item.frozen === 0 && item.charged === 0 && item.refunded === 0
            )
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_60, _cache[23] || (_cache[23] = [
                  _createElementVNode("p", null, "No credit card operations found", -1)
                ])))
              : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showTransactionsDialog.value = true))
          }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode(" Transactions ")
            ])),
            _: 1,
            __: [24]
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "section-title" }, "FINISH PAYMENT", -1)),
      (isFieldOperator.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createVNode(_component_el_alert, {
              title: "Manual transactions are not available for Field Operator",
              description: "Your role does not have permission to execute manual transactions in this trip finance section.",
              type: "info",
              closable: false,
              "show-icon": ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "payment-label" }, "Type", -1)),
                _createVNode(_component_el_select, {
                  modelValue: paymentType.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentType).value = $event)),
                  placeholder: "Select type",
                  class: "payment-select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Deposit",
                      value: "deposit"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Service",
                      value: "service"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Fines",
                      value: "fines"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "payment-label" }, "Action", -1)),
                _createVNode(_component_el_radio_group, {
                  modelValue: paymentAction.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentAction).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "charge" }, {
                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createTextVNode("Charge")
                      ])),
                      _: 1,
                      __: [27]
                    }),
                    _createVNode(_component_el_radio_button, { label: "freeze" }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("Freeze")
                      ])),
                      _: 1,
                      __: [28]
                    }),
                    _createVNode(_component_el_radio_button, { label: "unfreeze" }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode("Unfreeze")
                      ])),
                      _: 1,
                      __: [29]
                    }),
                    _createVNode(_component_el_radio_button, { label: "refund" }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode("Refund")
                      ])),
                      _: 1,
                      __: [30]
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "payment-label" }, "Amount", -1)),
                _createVNode(_component_el_input, {
                  modelValue: paymentAmount.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paymentAmount).value = $event)),
                  placeholder: "Enter amount",
                  type: "number"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, { onClick: setFullAmount }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("Full")
                      ])),
                      _: 1,
                      __: [32]
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_el_button, {
                  type: "success",
                  class: "finish-btn",
                  onClick: processPayment,
                  loading: processingPayment.value
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode(" FINISH ")
                  ])),
                  _: 1,
                  __: [34]
                }, 8, ["loading"])
              ])
            ])
          ]))
    ]),
    _createVNode(DiscountModal, {
      visible: showDiscountDialog.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showDiscountDialog).value = $event)),
      discounts: appliedDiscounts.value,
      "processing-discount": processingDiscount.value,
      "removing-discount": removingDiscount.value,
      onApplyDiscount: handleApplyDiscount,
      onRemoveDiscount: removeDiscountHandler
    }, null, 8, ["visible", "discounts", "processing-discount", "removing-discount"]),
    _createVNode(_component_el_dialog, {
      modelValue: showTransactionsDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showTransactionsDialog).value = $event)),
      title: "Transactions",
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_el_tabs, {
            modelValue: activeTransactionTab.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeTransactionTab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "Deposit",
                name: "deposit"
              }, {
                default: _withCtx(() => [
                  _createVNode(TransactionsTable, { transactions: depositTransactions.value }, null, 8, ["transactions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Service",
                name: "service"
              }, {
                default: _withCtx(() => [
                  _createVNode(TransactionsTable, { transactions: serviceTransactions.value }, null, 8, ["transactions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "Fines",
                name: "fines"
              }, {
                default: _withCtx(() => [
                  _createVNode(TransactionsTable, { transactions: finesTransactions.value }, null, 8, ["transactions"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})